module.exports = __webpack_public_path__ + "img/not-available.bb4cbed3.jpg";